import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';

export const INITIAL_FORM_ACCOUNT_NAME = 'initialFormAccountName';

export const useInitialFormAccountName = queryParamHookFactory(INITIAL_FORM_ACCOUNT_NAME);
